<template>

    <q-select
        class="mw-form-v2-select"
        :filled="settings.theme.input.filled"
      :outlined="settings.theme.input.outlined"
      :standout="settings.theme.input.standout"
      :borderless="settings.theme.input.borderless"
      :rounded="settings.theme.input.rounded"
      :square="settings.theme.input.square"
      :dense="settings.theme.input.dense" v-model="fieldValue"

              :options="optionsForSelect"
              emit-value
              option-value="value"
              option-label="label"
              map-options
              debounce="500"
              :label="field.layout_injected_label ? field.layout_injected_label : field.label"
              :rules="field.required ? [ val => val && val.length > 0 || requiredText] : []"
              :hide-bottom-space="hide_bottom_space"
    >
       <template v-slot:label>
         {{field.layout_injected_label ? field.layout_injected_label : field.label}}
      <OptionalLabel :field="field"></OptionalLabel>
      </template>
    </q-select>

</template>

<script>
import {mapFields} from "vuex-map-fields";
import OptionalLabel from "@/components/OptionalLabel";
export default {
  props: {
    modelValue: {},
    field:{},
    hide_bottom_space: null
  },
  data() {
    return {
      value: null
    };
  },
  components: {OptionalLabel},
  emits: ['update:modelValue'],
  methods: {

  },
  computed: {
    ...mapFields('settings/list', {
      settings: 'settings'
    }),
    requiredText: function () {
      return this.field.required_text ? this.field.required_text : 'Please select something';
    },
    optionsForSelect: function () {
      let data = [];
      for (const [key, value] of Object.entries(this.field.options)) {
        data.push( {
          label: value,
          value: key
        });
      }
      return data;
    },
    fieldValue: {
      get() {
        return this.modelValue;
      },
      set(value) {
        this.$emit('update:modelValue', value);
      },
    }
  },
  mounted() {

  }
}
</script>
